module.exports = __webpack_public_path__ + "static/media/hostscreening.3326a7ac.png";